import { render, staticRenderFns } from "./reportTotal.vue?vue&type=template&id=f2584fb4&"
import script from "./reportTotal.vue?vue&type=script&lang=js&"
export * from "./reportTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports